import {useCallback, useContext} from 'react';
import {useDispatch} from 'react-redux';
import {TextColorPicker} from '~/common/FabricInvitation/EventCreateDesign/components/CardEditor/actions/ColorPicker/TextColorPicker';
import {FontsMobile} from '~/common/FabricInvitation/EventCreateDesign/components/CardEditor/actions/Dropdown/FontsMobile';
import {TextFormat} from '~/common/FabricInvitation/EventCreateDesign/components/CardEditor/actions/TextFormat/TextFormat';
import {TextSize} from '~/common/FabricInvitation/EventCreateDesign/components/CardEditor/actions/TextSize/TextSize';
import {SpacingHeight} from '~/common/FabricInvitation/EventCreateDesign/components/CardEditor/Mobile/Contents/SpacingHeight/SpacingHeight';
import {PhotoEditorBottomSheet} from '~/common/FabricInvitation/EventCreateDesign/components/CardEditor/Mobile/PhotoEditor/PhotoEditorBottomSheet';
import {TextEditorButtons} from '~/common/FabricInvitation/EventCreateDesign/components/CardEditor/Mobile/TextEditor/TextEditorButtons';
import {menuMappingKeys} from '~/common/FabricInvitation/EventCreateDesign/constants';
import {EventCreateContext} from '~/common/FabricInvitation/EventCreateDesign/EventCreateContext';
import {UPDATE_DESIGN_OPTIONS} from '~/common/fabric/reducers/fabricDesign/constants';

export const MWEditorDrawerContent = ({
  activeMenu,
  showMenu,
  scrollToTop,
  setActiveMenu,
  setShowMenu,
  isPhotoDrawer = false,
}) => {
  const {canvas, activeObjects} = useContext(EventCreateContext);
  const dispatch = useDispatch();
  const selectFirstTextObject = useCallback(() => {
    if (!activeObjects || activeObjects.length === 0) {
      const textObjects = canvas.getObjects().filter((obj) => obj.type === 'textbox');
      if (textObjects.length > 0) {
        canvas.setActiveObject(textObjects[0]);
        canvas.renderAll();
        return true;
      }
    }
    return false;
  }, [canvas, activeObjects]);

  const onKeyboardButtonClick = useCallback(() => {
    dispatch({
      type: UPDATE_DESIGN_OPTIONS,
      payload: {textAreaOpen: true},
    });
  }, [dispatch]);

  const onClickMenu = useCallback(
    (newMenu) => () => {
      selectFirstTextObject();
      setShowMenu(true);
      setActiveMenu(newMenu);
    },
    [selectFirstTextObject, setActiveMenu, setShowMenu]
  );

  if (!showMenu) return null;

  if (activeMenu === 'text') {
    return (
      <TextEditorButtons
        activeMenu={activeMenu}
        onClickMenu={onClickMenu}
        onKeyboardButtonClick={onKeyboardButtonClick}
      />
    );
  }
  if (activeMenu === menuMappingKeys.FONT_STYLE) {
    return <FontsMobile />;
  }
  if (activeMenu === menuMappingKeys.FONT_SIZE) {
    return <TextSize />;
  }
  if (activeMenu === menuMappingKeys.TEXT_FORMAT) {
    return <TextFormat />;
  }
  if (activeMenu === menuMappingKeys.SPACING) {
    return <SpacingHeight />;
  }
  if (activeMenu === menuMappingKeys.COLOR) {
    return <TextColorPicker isTextColorPicker />;
  }
  if (isPhotoDrawer) {
    return (
      <PhotoEditorBottomSheet
        scrollToTop={scrollToTop}
        setShowMenu={setShowMenu}
        showMenu={showMenu}
        uyoImage={activeObjects?.[0]}
      />
    );
  }

  return null;
};
